import Home from "./pages/Home";
import AdicionarObjetivo from "./pages/AdicionarObjetivo";
import AdicionarManualmente from "./pages/AdicionarManualmente";
import AportarMes from "./pages/AportarMes";
import OndeAportar from './pages/OndeAportar';
import ObjetivoDetalhes from './pages/ObjetivoDetalhes';
import ModalComplexo from "./components/ModalComplexoVue";
import ResumoPatrimonio from "./pages/ResumoPatrimonio";
import ReservaEgergencia from "./pages/ReservaEmergencia";
import CalendarioDividendo from "./pages/CalendarioDividendo";
import ModalDividendo from "./components/ModalDividendo";
// import Historico from "./pages/Historico";

const page = () => {
	if (document.querySelector('#home_page')) return Home;
	if (document.querySelector('#adicionarobjetivo_page')) return AdicionarObjetivo;
	if (document.querySelector('#adicionarmanualmente_page')) return AdicionarManualmente;
	if (document.querySelector('#aportarmes_page')) return AportarMes;
	if (document.querySelector('#resumo_patrimonio-page')) return ResumoPatrimonio;
	if (document.querySelector('#ondeaportar_page')) return OndeAportar;
	if (document.querySelector('#objetivodetalhes_page')) return ObjetivoDetalhes;
	if (document.querySelector('#reserva_emergencia')) return ReservaEgergencia;
	if (document.querySelector('#calendario_page')) return CalendarioDividendo;
	// if (document.querySelector('#historico_page')) return Historico;



	else return null
}


const versaoCacheSpan = document.querySelector('#versao-cache');

// versaoCacheSpan?.innerText = '10-11-2023'



const { vMaska } = Maska


let app


(function () {
	if (!page()) return
	app = Vue.createApp(page());
	app.config.globalProperties.$console = console.log
	app.directive('maska', vMaska)
	app.component('modal-complexo', ModalComplexo);
	app.component('modal-dividendo', ModalDividendo);
	app.component('vue-datepicker', VueDatePicker)
	app.component('v-select', window["vue-select"]);
	app.mount("#app")
})()



window.instance = app;